<template>
  <v-app id="inspire" dark>
    <v-navigation-drawer
      clipped
      fixed
      v-model="drawer"
      app
      v-if="isAuthenticated"
    >
      <v-list dense>
        <router-link v-for="item in items" :key="item.title" tag="v-list-tile" :to=item.link exact>
          <v-list-tile-action>
            <v-icon>{{ item.icon }}</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>{{ item.title }}</v-list-tile-title>
          </v-list-tile-content>
        </router-link>
      </v-list>
    </v-navigation-drawer>
    <v-toolbar app fixed clipped-left v-if="isAuthenticated">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>{{ applicationName }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <div class="text-xs-center" color="primary">
        <v-chip label outline color="red"> {{ getName }}</v-chip>
      </div>
      <v-btn color="error" dark @click="logout">Logout</v-btn>
    </v-toolbar>
    <v-content>
      <v-container fluid :fill-height="!isAuthenticated">
        <v-flex
          xs12
          id="flex-main"
        >
          <router-view></router-view>
        </v-flex>
      </v-container>
    </v-content>
    <v-footer app fixed v-if="isAuthenticated">
      <v-layout mx-3>
        <!--<span> &copy; pixio {{ year }}</span>-->
        <v-spacer></v-spacer>
        <span>{{version}}</span>
      </v-layout>
    </v-footer>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import axios from 'axios'
import store from './store'

export default {
  data: () => ({
    applicationName: 'PIXIO Codes Tool',
    version: '4.1',
    drawer: true,
    year: 2018,
    items: [
      { title: 'Distributors', icon: 'store', link: '/distributors' },
      { title: 'Codes', icon: 'code', link: '/codes' },
      { title: 'Statistics', icon: 'content_paste', link: '/statistics' },
      { title: 'SKU List', icon: 'assignment', link: '/sku' },
      { title: 'Countries', icon: 'map', link: '/countries' }
    ]
  }),
  props: {
    source: String
  },
  methods: {
    logout: async function () {
      await this.$store.dispatch('logout')
      this.$router.push('login')
    }
  },
  computed: {
    ...mapGetters([
      'isAuthenticated',
      'getName'
    ])
  },
  created: function () {
    axios.interceptors.response.use(undefined, function (err) {
      return new Promise(function (resolve, reject) {
        if (err.status === 401 && err.config && !err.config.__isRetryRequest) {
          this.$store.dispatch('logout')
          this.$router.push('login')
        }
        throw err
      })
    })
    store.dispatch('auth')
  }
}
</script>
<style>
  .router-link-exact-active, .router-link-active {
    color: #EF5350;
  }
  #flex-main {
   max-width: 1200px;
  }
  @media only screen and (min-width: 1024px) {
    #flex-main {
      width: 90%;
      margin: auto;
    }
  }
  @media only screen and (min-width: 1092px) {
    #flex-main {
      width: 85%;
    }
  }
  @media only screen and (min-width: 1229px) {
    #flex-main {
      width: 75%;
    }
  }
  @media only screen and (min-width: 1264px) {
    #flex-main {
      width: 95%;
    }
  }
  @media only screen and (min-width: 1350px) {
    #flex-main {
      width: 90%;
    }
  }
  @media only screen and (min-width: 1400px) {
    #flex-main {
      width: 83%;
    }
  }
  @media only screen and (min-width: 1500px) {
    #flex-main {
      width: 77%;
    }
  }
  @media only screen and (min-width: 1600px) {
    #flex-main {
      width: 70%;
    }
  }
  @media only screen and (min-width: 1700px) {
    #flex-main {
      width: 65%;
    }
  }
  @media only screen and (min-width: 1800px) {
    #flex-main {
      width: 60%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue